module.exports = __webpack_public_path__ + "img/stock5.0fbb1693.png";